/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DnssecKeyList } from "../../models/dnssec-key-list";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface SetDomainDnssecKeys$Params {
  organisation_id: string;
  domain_id: string;
  check?: boolean;
  body: DnssecKeyList;
}

export function setDomainDnssecKeys(
  http: HttpClient,
  rootUrl: string,
  params: SetDomainDnssecKeys$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Status>> {
  const rb = new RequestBuilder(rootUrl, setDomainDnssecKeys.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("domain_id", params.domain_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Status>;
    }),
  );
}

setDomainDnssecKeys.PATH = "/surfdomeinen/organisations/{organisation_id}/dnssec/domains/{domain_id}";
